var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.3547 0 0 3.3544 0 7.5C0 11.6453 3.3544 15 7.5 15C11.6453 15 15 11.6456 15 7.5C15 3.3547 11.6456 0 7.5 0ZM1.17188 7.5C1.17188 4.00239 4.00216 1.17188 7.5 1.17188C8.99344 1.17188 10.4077 1.68604 11.5413 2.6301L2.6301 11.5413C1.68604 10.4077 1.17188 8.99344 1.17188 7.5ZM7.5 13.8281C6.00656 13.8281 4.59231 13.314 3.45873 12.3699L12.3699 3.4587C13.314 4.59231 13.8281 6.00656 13.8281 7.5C13.8281 10.9976 10.9978 13.8281 7.5 13.8281Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableIcon);
export default __webpack_public_path__ + "static/media/disable-icon.2a7bbcba05ba79ef8042b6576d833095.svg";
export { ForwardRef as ReactComponent };